import { render, staticRenderFns } from "./DomainChangeOption.vue?vue&type=template&id=1b4c606f&scoped=true"
import script from "./DomainChangeOption.vue?vue&type=script&lang=js"
export * from "./DomainChangeOption.vue?vue&type=script&lang=js"
import style0 from "./DomainChangeOption.vue?vue&type=style&index=0&id=1b4c606f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4c606f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b4c606f')) {
      api.createRecord('1b4c606f', component.options)
    } else {
      api.reload('1b4c606f', component.options)
    }
    module.hot.accept("./DomainChangeOption.vue?vue&type=template&id=1b4c606f&scoped=true", function () {
      api.rerender('1b4c606f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DomainChangeOption/DomainChangeOption.vue"
export default component.exports